import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteSquadImageAPI,
  fetchSquadImagesAPI,
  uploadSquadImagesAPI,
} from "./squadImagesAPI";
import { showModal } from "../../statusModal/statusModal";

const initialState = {
  list: [],
  fetchStatus: "idle",
  uploadStatus: "idle",
  deleteStatus: "idle",
  error: null,
};

export const fetchSquadImages = createAsyncThunk(
  "squadImages/fetchImages",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const data = await fetchSquadImagesAPI();
      return data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch images"
      );
    }
  }
);

export const deleteSquadImage = createAsyncThunk(
  "squadImages/deleteSquadImage",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const data = await deleteSquadImageAPI(id);
      dispatch(
        showModal({
          message: `تم حذف الصوره بنجاح`,
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء حذف الصوره", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete image"
      );
    }
  }
);

export const uploadSquadImage = createAsyncThunk(
  "squadImages/uploadSquadImage",
  async (imageData, { dispatch, rejectWithValue }) => {
    try {
      const data = await uploadSquadImagesAPI(imageData);
      dispatch(
        showModal({
          message: `تم رفع الصوره بنجاح`,
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء رفع الصوره", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete admins"
      );
    }
  }
);

const squadImagesSlice = createSlice({
  name: "squadImages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSquadImages.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchSquadImages.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.list = action.payload.data;
      })
      .addCase(fetchSquadImages.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(uploadSquadImage.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
      })
      .addCase(uploadSquadImage.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(uploadSquadImage.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(deleteSquadImage.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
      })
      .addCase(deleteSquadImage.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.list = state.list.filter(({ _id }) => _id !== action.payload);
      })
      .addCase(deleteSquadImage.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.error = action.payload.error;
      });
  },
});

export default squadImagesSlice.reducer;
